import React, {useState} from "react";
import classes from "./login.module.css";
import Spinner from "react-spinners/BeatLoader";
import {useNavigate} from "react-router-dom";
import {Button, Checkbox, FormControlLabel, TextField} from "@mui/material";
import useAxiosInstance from "../useAxiosInstance";
import Swal from "sweetalert2";
import loginImage from "../assets/loginLogo.jpg";

const Login = () => {
    const navigate = useNavigate();
    const instance = useAxiosInstance();

    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
    });

    const [IsSpinner, setIsSpinner] = useState(false);
    const [show, setShow] = useState(false);
    const [values, setValues] = useState({
        email: "",
        password: ""
    });
    const inputs = [
        {
            id: 0,
            name: "email",
            placeholder: "Email",
            label: "Email",
            required: true,
        },
        {
            id: 1,
            name: "password",
            type: show ? 'text' : 'password',
            placeholder: "Password",
            label: "Password",
            required: true,
        },
    ];

    const onChange = (e) => {
        setValues(prevState => ({...prevState, [e.target.name]: e.target.value}))
    };
    const handleSubmit = (event) => {
        event.preventDefault();

        if (!values.email || !values.password) {
            Swal.fire("Please Fill all the Fields.");
            return;
        }
        setIsSpinner(true);

        login({
            email: values.email,
            password: values.password
        });
    };
    const login = (objToBeSend) => {
        instance.post('Auth/login', {
            username: objToBeSend.email,
            password: objToBeSend.password
        })
            .then((response) => {
                localStorage.setItem('_MIHEALTHTOKEN', response.token);
                setValues({email: "", password: ""});
                navigate("/home");
                Toast.fire({
                    icon: "success",
                    title: "Logged in Successfully"
                });
                setIsSpinner(false);
            })
            .catch(() => {
            }).finally(() => {
            setIsSpinner(false);
        });
    }

    return (
        <div className={classes.main}>
            <div className={classes.innerMain}>
                <div className={classes.imageContainer}>
                    <img src={loginImage} alt="loginLogo"/>
                </div>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <h1 className="text-center mb-4" style={{letterSpacing: 1}}>Log in to your account.</h1>
                    {inputs.map((input) => (
                        <TextField
                            key={input.id}
                            size="small" type={input.type} className="w-100 mb-3" onChange={onChange}
                            name={input.name}
                            label={input.label}
                            value={values[input.name]}/>
                    ))}
                    <div className="d-flex align-items-center justify-content-between px-3 flex-wrap">
                        <Spinner color='#00c292' loading={IsSpinner}/>
                        <FormControlLabel control={<Checkbox onChange={(e) => setShow(e.target.checked)}/>}
                                          label="Show Passwords"/>
                        <Button variant="contained" type="submit">Submit</Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
